export default __webpack_public_path__ + "static/media/third.1670812a.m4a";